import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

export const LeadChurnListContext = React.createContext();

export const ActionTypes = {
  UPDATE_LEADCHURNLIST_TABLE_SETTINGS: 'UPDATE_LEADCHURNLIST_TABLE_SETTINGS',
};

const defaultPagination = {
  current: 0,
  defaultPageSize: 100,
};

const initialState = {
  tableActions: {
    pagination: defaultPagination,
    filters: null,
    sorter: null,
  },
  defaultTableActions: {
    pagination: defaultPagination,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_LEADCHURNLIST_TABLE_SETTINGS: {
      const { payload } = action;
      return {
        ...state,
        tableActions: payload,
      };
    }
    default:
      throw new Error();
  }
};

const LeadChurnListProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <LeadChurnListContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </LeadChurnListContext.Provider>
  );
};

LeadChurnListProvider.propTypes = {
  children: PropTypes.node,
};

export default React.memo(LeadChurnListProvider);
